export const menuList = {
	display: 'flex',
	height: '100%',
	flexDirection: 'column',
	justifyContent: 'space-between',
};

export const navigationWrapper = {
	backgroundColor: 'white',
	padding: '2.5rem 1.25rem',
};

export const listItemsWrapper = {
	gap: '0.5rem',
	display: 'flex',
	flexDirection: 'column',
};

export const menuItemWrapper = ({ isActiveItem }: { isActiveItem: boolean }) => ({
	padding: '1rem 0.5rem',
	gap: '0.25rem',
	height: '4rem',
	width: '16.25rem',
	borderRadius: '0.5rem',
	backgroundColor: isActiveItem ? 'neutrals.neutral' : 'transparent',
	lineHeight: isActiveItem ? '1.75rem' : '1.5rem',
});

export const logoutItemWrapper = {
	padding: '1rem 0.5rem',
	gap: '0.25rem',
	borderRadius: '0.5rem',
	height: '4rem',
	width: '16.25rem',
	position: 'sticky',
	bottom: '2.5rem',
};
